import React from 'react';
import { UploadIcon } from '@common-fe/common-fe';

import {
  ImgThumbInner,
  ImgThumbOuter,
  UploadContent,
  UploadText,
} from '@/components/controls/DropScan/ScanPreview/ScanPreview.styles';

interface AddFileButtonProps {
  onOpenUpload?: () => void;
}

const AddFileButton: React.FC<AddFileButtonProps> = ({ onOpenUpload }) => {
  return (
    <ImgThumbOuter active={false} isScanUpload onClick={onOpenUpload}>
      <ImgThumbInner>
        <UploadContent>
          <UploadIcon color="iconAccent" />
          <UploadText>Add File</UploadText>
        </UploadContent>
      </ImgThumbInner>
    </ImgThumbOuter>
  );
};

export default AddFileButton;
